import { render, staticRenderFns } from "./WorkDetailsForm.vue?vue&type=template&id=00e236d4&"
import script from "./WorkDetailsForm.vue?vue&type=script&lang=js&"
export * from "./WorkDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports